import script from "./AppHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppHeader.vue?vue&type=script&lang=ts&setup=true"

import "./AppHeader.vue?vue&type=style&index=0&id=09dad28a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09dad28a"]])

export default __exports__